import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const contactType = createSlice({
  name: "contactType",
  initialState: "customers" as string, // Explicitly type the state as a string
  reducers: {
    setContactType: (_state, action: PayloadAction<string>) => {
      return action.payload; 
    },
  },
});

export const { setContactType } = contactType.actions;

export default contactType.reducer;
